<template>
  <a-layout class="layout" style="height: 100vh">
    <a-layout-header>
      <div class="logo" />
      <a-menu
          :selectedKeys="[current]"
          theme="dark"
          mode="horizontal"
          :style="{ lineHeight: '64px' }"
      >
        <a-menu-item key="fafact" @click="goto('/faFact')">FA_FACT_45_02_1_0_S.trk</a-menu-item>
        <a-menu-item key="ch2bet" @click="goto('/ch2bet')">ch2bet.nii</a-menu-item>
        <a-menu-item key="trsr" @click="goto('/trsr')">TR_S_R.nii.gz</a-menu-item>
<!--        <a-menu-item key="hcp1065" @click="goto('/hcp')">HCP1065.2mm.nii.gz</a-menu-item>-->
      </a-menu>
    </a-layout-header>
    <a-layout-content style="padding: 16px 16px">
      <div :style="{ background: '#fff', padding: '8px', minHeight: '280px', height:'100%', overflow: 'hide' }">
        <slot name="mainContent"></slot>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>

export default {
  name: "humanNav",
  props:{
    current : String
  },
  methods:{
    goto(value){
      // this.$router.push(value);
     console.log(window.location, value)
      window.open(window.location.origin + "/#" +  value, "_blank");
    }
  }
}
</script>

<style scoped>

</style>